import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthSignalService } from '../services/auth-signal.service';

export const adminGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthSignalService);

  console.log('AdminGuard running');
  
  // Verificar si hay un usuario autenticado
  const isAuthenticated = authService.isAuthenticated();
  
  if (!isAuthenticated) {
    console.log('No authenticated user, redirecting to login');
    router.navigate(['/auth/login']);
    return false;
  }
  
  // Obtener usuario actual
  const currentUser = authService.account();
  
  // Verificar si el usuario es administrador
  // Esto dependerá de cómo se identifica un admin en tu aplicación
  const isAdmin = currentUser && (
    (currentUser.role !== undefined && currentUser.role === 'ADMIN') || 
    (currentUser.isAdmin !== undefined && currentUser.isAdmin === true) ||
    (currentUser.permissions !== undefined && currentUser.permissions.includes('ADMIN'))
  );
  
  if (isAdmin) {
    console.log('User is admin, proceeding');
    return true;
  } else {
    console.log('User is not admin, redirecting to dashboard');
    
    // Navegar al dashboard con pequeño delay para asegurar que se complete
    setTimeout(() => {
      router.navigate(['/dashboard']);
    }, 50);
    
    return false;
  }
};